export default () => {
    this.isEdge = /edge/i.test(navigator.userAgent);
    this.isChrome = /chrome|CriOS/i.test(navigator.userAgent) && !this.isEdge;
    this.isSafari = /safari/i.test(navigator.userAgent) && !this.isChrome && !this.isEdge;
    this.isFirefox = /firefox/i.test(navigator.userAgent);
    this.isLegacyIE = !!(window.ActiveXObject);
    this.isIE = this.isLegacyIE || /trident.*rv:1\d/i.test(navigator.userAgent);
    this.isIE11 = /trident.*rv:11/i.test(navigator.userAgent);
    this.isChromecast = this.isChrome && /CrKey/i.test(navigator.userAgent);
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Mobile Safari|Opera Mini/i.test(navigator.userAgent);
    this.isiOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
    this.isAndroid = /Android/i.test(navigator.userAgent);
    this.isWindowsPhone = /Windows Phone/i.test(navigator.userAgent);
    this.isWin8App = /MSAppHost/i.test(navigator.userAgent);
    this.isWiiU = /WiiU/i.test(navigator.userAgent);
    this.isPS4 = /PlayStation 4/i.test(navigator.userAgent);
};